import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const splitSettlements = (tokens: any, userAccessToken: string, req: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.createSplitSettlements,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: req,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { splitSettlements }
